import {
	ADMINGETKYCDOCUMENTLIST_SUCCESS,
	ADMINGETKYCDOCUMENTLIST_FAILED,
	RESET_ADMINGETKYCDOCUMENTLIST,
	LOADING_ADMINGETKYCDOCUMENTLIST,
	NETWORK_ERROR_ADMINGETKYCDOCUMENTLIST
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetKycDocumentList = () => {
	return { type: RESET_ADMINGETKYCDOCUMENTLIST };
};

const adminGetKycDocumentList = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGETKYCDOCUMENTLIST });
	await adminServices
		.post("getKycDocumentTypeList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetKycDocumentListsuccess(res.data));
					break;
				default:
					dispatch(adminGetKycDocumentListFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGETKYCDOCUMENTLIST,
				payload: err
			});
		});
};
function adminGetKycDocumentListsuccess(data) {
	return {
		type: ADMINGETKYCDOCUMENTLIST_SUCCESS,
		payload: data
	};
}
function adminGetKycDocumentListFailed(data) {
	return {
		type: ADMINGETKYCDOCUMENTLIST_FAILED,
		payload: data
	};
}

export { resetAdminGetKycDocumentList, adminGetKycDocumentList };
